(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7652],{

/***/ 56771:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/_internal/for-sale/[address_id]",
      function () {
        return __webpack_require__(50762);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _address_id_; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Box.tsx
var Box = __webpack_require__(22901);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/index.ts + 4 modules
var helpers = __webpack_require__(68139);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/useTrackProperty.ts
var useTrackProperty = __webpack_require__(18305);
// EXTERNAL MODULE: ./src/components/marketplace/property/index.ts + 7 modules
var marketplace_property = __webpack_require__(60793);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Col.tsx
var Col = __webpack_require__(55128);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/Header.tsx + 3 modules
var Header = __webpack_require__(60589);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(79758);
;// CONCATENATED MODULE: ./src/components/properties/components/CoverImages.tsx
// Homes Placeholder SVG
var FALLBACK_URL = "https://images.opendoor.com/source/s3/imgdrop-production/ce1501221958405990f1d0d7fe935c51.svg?preset=square-2048";

;// CONCATENATED MODULE: ./src/components/properties/helpers/property.ts



function getHumanReadableAddress(street, unitType, unitNumber, city, state, postalCode) {
    var formattedStreet = (0,helpers/* formatStreetAddress */.Dm)(street, unitType, unitNumber);
    if (!formattedStreet || !city || !state || !postalCode) {
        return "";
    }
    return "".concat(formattedStreet, ", ").concat(city, ", ").concat(state, " ").concat(postalCode);
}
var getReadableListingStatus = function(listingState) {
    if (!listingState) {
        return "Unknown";
    }
    if (listingState === "SELL_REQUEST_TEMP_OFF_MARKET") {
        return "Off Market";
    }
    return listingState.substring("SELL_REQUEST_".length).split("_").map(function(input) {
        return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
    }).join(" ");
};
var getSeoFields = function(addressId, displaySlug, status, street, unitType, unitNumber, city, state, postalCode, sqFtLot, bedrooms, bathrooms, yearBuilt, coverImageProp) {
    var ref;
    var readableAddress = getHumanReadableAddress(street, unitType, unitNumber, city, state, postalCode);
    var title = "Home for sale - ".concat(readableAddress, " | Opendoor");
    var canonicalUrl = displaySlug ? "".concat(globals/* COSMOS_URL */.EQ, "/properties/").concat(displaySlug, "/aid_").concat(addressId) : "".concat(globals/* COSMOS_URL */.EQ, "/properties/").concat(street ? "".concat((ref = street === null || street === void 0 ? void 0 : street.toLowerCase()) === null || ref === void 0 ? void 0 : ref.replaceAll(" ", "-"), "-") : "").concat(unitNumber ? "".concat(unitNumber, "-") : "").concat(city ? "".concat(city === null || city === void 0 ? void 0 : city.toLowerCase(), "-") : "", "-").concat(state === null || state === void 0 ? void 0 : state.toLowerCase()).concat(postalCode, "/aid_").concat(addressId);
    var forSale = getReadableListingStatus(status) === "Active";
    var metaDescription = "".concat(readableAddress, " is currently ").concat(forSale ? "for sale" : "not for sale", ". The ").concat(sqFtLot ? "".concat(sqFtLot, " sq ft.") : "", " home ").concat(yearBuilt ? "was built in ".concat(yearBuilt) : "", " ").concat(bedrooms ? "and has ".concat(bedrooms, " bedrooms") : "", " ").concat(bathrooms ? "and has ".concat(bathrooms, " bathrooms") : "", ". Learn more about the home on Opendoor.");
    var coverImage = FALLBACK_URL;
    if (coverImageProp) {
        // Use a larger preset so link previews (iMessage/SMS, Facebook, Twitter, WhatsApp)
        // render a high-quality hero image rather than a tiny thumbnail.
        coverImage = "".concat(coverImageProp, "?").concat(new URLSearchParams({
            preset: "3:2-lg",
            service: "cosmos"
        }).toString());
    }
    return {
        readableAddress: readableAddress,
        canonicalUrl: canonicalUrl,
        metaDescription: metaDescription,
        title: title,
        coverImage: coverImage
    };
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_@types+react-dom@18.3.7_@types+react@18.3.28__@types+rea_8a835da27f6bd732d06ca598c0c17f05/node_modules/next/head.js
var head = __webpack_require__(62071);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/properties/shared/SeoHead.tsx




var getBaseTags = function(props) {
    return [
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
            children: props.title
        }, "title"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "description",
            content: props.metaDescription
        }, "description"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "author",
            content: props.author
        }, "author"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
            rel: "canonical",
            href: props.canonicalUrl
        }, "canonical"), 
    ];
};
var getOgTags = function(props) {
    if (!props) {
        return null;
    }
    var url = props.url, title = props.title, description = props.description, image = props.image, imageAlt = props.imageAlt, siteName = props.siteName, type = props.type;
    var tags = [
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:title",
            content: title
        }, "og:title"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:url",
            content: url
        }, "og:url"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:type",
            content: type
        }, "og:type"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:description",
            content: description
        }, "og:description"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:image",
            content: image
        }, "og:image"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:image:secure_url",
            content: image
        }, "og:image:secure_url"),
        imageAlt ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:image:alt",
            content: imageAlt
        }, "og:image:alt") : null,
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:site_name",
            content: siteName
        }, "og:site_name"), 
    ];
    return tags;
};
// Twitter card tags are read by iMessage/SMS previews, Twitter/X, Slack, and
// other messaging clients. Without them they fall back to the site-wide
// defaults set in `_app.tsx`, which show the Opendoor logo instead of the
// property's hero photo.
var getTwitterTags = function(props) {
    if (!props) {
        return null;
    }
    var url = props.url, title = props.title, description = props.description, image = props.image, imageAlt = props.imageAlt;
    return [
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "twitter:card",
            content: "summary_large_image"
        }, "twitter:card"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "twitter:url",
            content: url
        }, "twitter:url"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "twitter:title",
            content: title
        }, "twitter:title"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "twitter:description",
            content: description
        }, "twitter:description"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "twitter:image",
            content: image
        }, "twitter:image"),
        imageAlt ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "twitter:image:alt",
            content: imageAlt
        }, "twitter:image:alt") : null, 
    ];
};
var getPropertySchemaData = function(props) {
    var address = props.address, floorSize = props.floorSize, listPrice = props.listPrice, url = props.url, lat = props.lat, lon = props.lon, hasSelfTour = props.hasSelfTour, addressToken = props.addressToken, remainingProps = (0,_object_without_properties/* default */.Z)(props, [
        "address",
        "floorSize",
        "listPrice",
        "url",
        "lat",
        "lon",
        "hasSelfTour",
        "addressToken"
    ]);
    var schemaData = (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org/",
        "@type": [
            "SingleFamilyResidence",
            "Product"
        ]
    }, address && {
        address: (0,_object_spread/* default */.Z)({
            "@type": "PostalAddress"
        }, address)
    }, lat && lon && {
        geo: {
            "@type": "GeoCoordinates",
            latitude: lat,
            longitude: lon
        }
    }, floorSize && {
        floorSize: (0,_object_spread/* default */.Z)({
            "@type": "QuantitativeValue"
        }, floorSize)
    }, hasSelfTour && addressToken && {
        tourBookingPage: "https://consumer.opendoor.com/dashboard/buy/tour?id=".concat(addressToken)
    }, listPrice && url && {
        offers: {
            "@type": "Offer",
            priceCurrency: "USD",
            price: listPrice,
            url: url,
            availability: "http://schema.org/InStock"
        }
    }, remainingProps);
    return schemaData;
};
var SeoHead = function(props) {
    var base = props.base, og = props.og, schema = props.schema;
    // ensure that you don't nest tags inside of fragments
    // if you do that, then the next head component
    // will have issues with overrides
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
        children: [
            getBaseTags(base),
            getOgTags(og),
            getTwitterTags(og),
            schema && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(getPropertySchemaData(schema))
                }
            })
        ]
    });
};
/* harmony default export */ var shared_SeoHead = (SeoHead);

// EXTERNAL MODULE: ./src/components/shared/GlobalStyles.tsx
var GlobalStyles = __webpack_require__(62551);
;// CONCATENATED MODULE: ./src/components/properties/shared/MarketplaceLayout.tsx











var mainNavLinks = [
    {
        name: "How it works",
        href: "/how-it-works-sell"
    },
    {
        name: "Browse homes",
        href: "/homes"
    }, 
];
var menuPanelNavLinks = [
    {
        name: "Work with a builder",
        href: "/builder"
    },
    {
        name: "Opendoor for Agents",
        href: "/agents"
    }, 
];
var MarketplaceLayout = function(param) {
    var children = param.children, property = param.property, navHeader = param.navHeader;
    var ref;
    var ref1;
    var resolvedMainNavLinks = (ref1 = navHeader === null || navHeader === void 0 ? void 0 : navHeader.mainNavLinks) !== null && ref1 !== void 0 ? ref1 : mainNavLinks;
    var ref2;
    var resolvedMenuPanelNavLinks = (ref2 = navHeader === null || navHeader === void 0 ? void 0 : navHeader.menuPanelNavLinks) !== null && ref2 !== void 0 ? ref2 : menuPanelNavLinks;
    var megaNavData = navHeader === null || navHeader === void 0 ? void 0 : navHeader.megaNavData;
    var ref3 = getSeoFields(property === null || property === void 0 ? void 0 : property.addressToken, property === null || property === void 0 ? void 0 : property.slug, undefined, property === null || property === void 0 ? void 0 : property.street, property === null || property === void 0 ? void 0 : property.unitType, property === null || property === void 0 ? void 0 : property.unitNumber, property === null || property === void 0 ? void 0 : property.city, property === null || property === void 0 ? void 0 : property.state, property === null || property === void 0 ? void 0 : property.zip, property === null || property === void 0 ? void 0 : property.sqFtLot, property === null || property === void 0 ? void 0 : property.bedrooms, property === null || property === void 0 ? void 0 : property.bathrooms, property === null || property === void 0 ? void 0 : property.yearBuilt, property === null || property === void 0 ? void 0 : (ref = property.photos) === null || ref === void 0 ? void 0 : ref[0]), coverImage = ref3.coverImage, readableAddress = ref3.readableAddress, title = ref3.title, canonicalUrl = ref3.canonicalUrl;
    var metaDescription = "View photos, details, and schedule a self-tour of this ".concat(property === null || property === void 0 ? void 0 : property.bedrooms, " bedroom, ").concat(property === null || property === void 0 ? void 0 : property.bathrooms, " bathroom, ").concat(property === null || property === void 0 ? void 0 : property.sqFtTotalLiving, " sqft home located at ").concat(readableAddress, ".");
    var seoHead = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_SeoHead, {
        base: {
            title: title,
            author: "Opendoor, Inc.",
            metaDescription: metaDescription,
            canonicalUrl: canonicalUrl
        },
        og: {
            url: canonicalUrl,
            title: title,
            description: metaDescription,
            siteName: "Opendoor",
            image: coverImage,
            imageAlt: readableAddress ? "Photo of home for sale at ".concat(readableAddress) : "Home for sale on Opendoor",
            type: "website"
        },
        schema: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            name: readableAddress,
            description: metaDescription,
            url: canonicalUrl,
            address: (0,_object_spread/* default */.Z)({}, (property === null || property === void 0 ? void 0 : property.street) && {
                streetAddress: (0,helpers/* formatStreetAddress */.Dm)(property.street, property.unitType, property.unitNumber) || undefined
            }, (property === null || property === void 0 ? void 0 : property.city) && {
                addressLocality: property.city
            }, (property === null || property === void 0 ? void 0 : property.state) && {
                addressRegion: property.state
            }, (property === null || property === void 0 ? void 0 : property.zip) && {
                postalCode: property.zip
            })
        }, (property === null || property === void 0 ? void 0 : property.sqFtLot) && {
            floorSize: {
                value: property.sqFtLot.toString()
            }
        }, (property === null || property === void 0 ? void 0 : property.yearBuilt) && {
            yearBuilt: property.yearBuilt.toString()
        }, (property === null || property === void 0 ? void 0 : property.bedrooms) && {
            numberOfBedrooms: property.bedrooms.toString()
        }, (property === null || property === void 0 ? void 0 : property.bathrooms) && {
            numberOfBathroomsTotal: property.bathrooms.toString()
        }, (property === null || property === void 0 ? void 0 : property.listPrice) && !(0,helpers/* isBuyDirectEligible */.pX)(property) && {
            listPrice: property.listPrice
        }, (property === null || property === void 0 ? void 0 : property.buyDirectPrice) && (0,helpers/* isBuyDirectEligible */.pX)(property) && {
            listPrice: property.buyDirectPrice
        }), {
            image: coverImage,
            lat: property === null || property === void 0 ? void 0 : property.latitude,
            lon: property === null || property === void 0 ? void 0 : property.longitude
        }), (property === null || property === void 0 ? void 0 : property.canSelfTour) && {
            hasSelfTour: property === null || property === void 0 ? void 0 : property.canSelfTour
        }), {
            addressToken: property === null || property === void 0 ? void 0 : property.addressToken
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        href: "/fonts/graphik-regular/Graphik-Regular.woff2",
                        as: "font",
                        type: "font/woff2",
                        crossOrigin: "anonymous"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        href: "/fonts/graphik-semibold/Graphik-Semibold.woff2",
                        as: "font",
                        type: "font/woff2",
                        crossOrigin: "anonymous"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://cdn-cosmos.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://cdn-cosmos.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge,chrome=1"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "viewport",
                        content: "width=device-width,initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        httpEquiv: "Accept-CH",
                        content: "DPR, Width, Viewport-Width"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "apple-touch-icon",
                        sizes: "144x144",
                        href: "https://www.opendoor.com/apple-touch-icon-144.png"
                    })
                ]
            }),
            seoHead,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalStyles/* default */.Z, {
                fontWeights: [
                    "regular",
                    "semibold",
                    "bold",
                    "medium"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                backgroundColor: "$backgroundPrimary",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {
                        slug: "homes",
                        mainNavLinks: resolvedMainNavLinks,
                        menuPanelNavLinks: resolvedMenuPanelNavLinks,
                        megaNavData: megaNavData,
                        ctaTitle: navHeader === null || navHeader === void 0 ? void 0 : navHeader.ctaTitle,
                        ctaLink: navHeader === null || navHeader === void 0 ? void 0 : navHeader.ctaLink
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        tag: "main",
                        tabIndex: -1,
                        "$platform-web": {
                            overflowX: "hidden"
                        },
                        backgroundColor: "$backgroundPrimary",
                        children: children
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var shared_MarketplaceLayout = (MarketplaceLayout);

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_@types+react-dom@18.3.7_@types+react@18.3.28__@types+rea_8a835da27f6bd732d06ca598c0c17f05/node_modules/next/dynamic.js
var dynamic = __webpack_require__(5984);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/helpers/observability.ts + 11 modules
var observability = __webpack_require__(50138);
;// CONCATENATED MODULE: ./src/pages/marketplace/_internal/for-sale/[address_id].tsx











var Lightbox = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 59919)).then(function(mod) {
        return mod.Lightbox;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59919)
            ];
        }
    },
    ssr: false
});
var ShareModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 57903)).then(function(mod) {
        return mod.ShareModal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57903)
            ];
        }
    },
    ssr: false
});
var PropertySection = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 10607)).then(function(mod) {
        return mod.PropertySection;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10607)
            ];
        }
    },
    ssr: false
});
var Page = function(props) {
    var property = props === null || props === void 0 ? void 0 : props.property;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(useTrackProperty/* PropertyAnalytics.Provider */.K.Provider, {
        value: {
            property: property
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageInner, (0,_object_spread/* default */.Z)({}, props))
    });
};
var PageInner = function(param) {
    var property = param.property, navHeader = param.navHeader;
    var trackProperty = (0,useTrackProperty/* useTrackProperty */.a)().trackProperty;
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var ref = (0,react.useState)(false), isLightboxOpen = ref[0], setIsLightboxOpen = ref[1];
    var ref1 = (0,react.useState)(false), isShareModalOpen = ref1[0], setIsShareModalOpen = ref1[1];
    var ref2 = (0,react.useState)(0), selectedPhotoIndex = ref2[0], setSelectedPhotoIndex = ref2[1];
    var toggleLightbox = (0,react.useCallback)(function() {
        return setIsLightboxOpen(function(prev) {
            return !prev;
        });
    }, []);
    // bricks-next `Lightbox` registers a document-level keydown listener that
    // fires `handleClose()` on Escape regardless of `isOpen`, so `handleClose`
    // must be close-only rather than a toggle.
    var closeLightbox = (0,react.useCallback)(function() {
        return setIsLightboxOpen(false);
    }, []);
    var handleSetSelectedPhotoIndex = (0,react.useCallback)(function(idx) {
        return setSelectedPhotoIndex(idx);
    }, []);
    var ref3 = (0,helpers/* usePropertyReactions */.O8)(property.addressToken, "REACTION_SOURCE_WEB_PDP"), isLiked = ref3.isLiked, onClickReaction = ref3.onClickReaction;
    /**
   * The initial page load for customers will include the cached similar properties.
   * This hook executes client-side to retrieve the latest similar listings.
   */ var marketplaceProperty = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, property), {
        isLiked: isLiked,
        onClickReaction: onClickReaction
    });
    var similarProperties = (0,helpers/* useSimilarProperties */.n6)(property.addressToken).similarProperties;
    if (similarProperties === null || similarProperties === void 0 ? void 0 : similarProperties.results) {
        marketplaceProperty.similarProperties = similarProperties;
    }
    var sellerDisclosures = (0,helpers/* useSellerDisclosures */.FZ)(property.addressToken).sellerDisclosures;
    if (sellerDisclosures) {
        marketplaceProperty.sellerDisclosuresDownloadUrl = sellerDisclosures;
    }
    var formattedAddress = (0,react.useMemo)(function() {
        return (0,helpers/* formatStreetAddress */.Dm)(property.street, property.unitType, property.unitNumber);
    }, [
        property.street,
        property.unitType,
        property.unitNumber
    ]);
    var carouselPhotos = (0,react.useMemo)(function() {
        return (0,helpers/* buildGalleryPhotos */.hk)(marketplaceProperty);
    }, [
        marketplaceProperty.photos,
        marketplaceProperty.floorPlanPhotos
    ]);
    (0,react.useEffect)(function() {
        trackProperty("property-view", "marketplace-pdp");
        trackJourneyEvent("marketplaceProperty", "detailPageView", {
            addressUuid: property.addressToken
        });
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_MarketplaceLayout, {
        property: marketplaceProperty,
        navHeader: navHeader,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            $smallerThanMD: {
                flexDirection: "column",
                overflowY: "scroll"
            },
            $largerThanSM: {
                flexDirection: "row",
                height: "calc(100vh - 72px)"
            },
            overflow: "hidden",
            width: "100vw",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* GalleryPhotos */.Ub, {
                    handleSetSelectedPhotoIndex: handleSetSelectedPhotoIndex,
                    property: marketplaceProperty,
                    toggleLightbox: toggleLightbox
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* PhotoCarousel */.cS, {
                    photos: carouselPhotos,
                    price: (marketplaceProperty === null || marketplaceProperty === void 0 ? void 0 : marketplaceProperty.displayBadge) === "ON_THE_MARKET" && (0,helpers/* isBuyDirectEligible */.pX)(marketplaceProperty) ? marketplaceProperty.buyDirectPrice : marketplaceProperty.listPrice,
                    address: formattedAddress,
                    toggleLightbox: toggleLightbox,
                    setSelectedPhotoIndex: handleSetSelectedPhotoIndex,
                    latitude: marketplaceProperty.latitude,
                    longitude: marketplaceProperty.longitude,
                    openShareModal: function() {
                        return setIsShareModalOpen(true);
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Lightbox, {
                    handleClose: closeLightbox,
                    isOpen: isLightboxOpen,
                    property: marketplaceProperty,
                    selectedPhotoIndex: selectedPhotoIndex
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertySection, {
                    property: marketplaceProperty
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShareModal, {
                    property: marketplaceProperty,
                    isOpen: isShareModalOpen,
                    onClose: function() {
                        return setIsShareModalOpen(false);
                    }
                })
            ]
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _address_id_ = (Page);


/***/ }),

/***/ 9825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78049);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24734);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__);






var SvgCheckmark = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size) {
        outProps.width = size;
        outProps.height = size;
    }
    if (color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "currentColor",
            d: "m9.218 15.319 9.967-9.966Q19.537 5 20.022 5q.486 0 .838.353.354.352.353.838 0 .484-.353.838L10.042 17.847q-.354.353-.824.353t-.823-.353L3.34 12.791A1.1 1.1 0 0 1 3 11.953a1.2 1.2 0 0 1 .367-.838q.353-.353.838-.353t.838.353z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgCheckmark);


/***/ }),

/***/ 55285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TextButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64069);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11141);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7238);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74609);
/* harmony import */ var _shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36838);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84402);











var textButtonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.textButton */ .T.textButton, buttonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.button */ .T.button;
var sharedFrameConfig = {
    name: "TextButton",
    display: "flex",
    flexDirection: "row",
    gap: textButtonTokens.padding.labelIconGap.default,
    userSelect: "none",
    cursor: "pointer",
    // Browser resets
    padding: 0,
    borderWidth: 0,
    backgroundColor: "$transparent",
    focusVisibleStyle: {
        outlineStyle: "solid",
        outlineWidth: textButtonTokens.borderWidth.state.default,
        outlineOffset: textButtonTokens.padding.state.focused.default,
        borderRadius: textButtonTokens.cornerRadius.state.focused
    },
    pressStyle: {
        scale: (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_2__/* .getStateTokenValue */ .GJ)(buttonTokens.state.pressedScale)
    },
    variants: {
        variant: function(variant) {
            return {
                focusVisibleStyle: {
                    outlineColor: variant === "secondaryInverse" ? textButtonTokens.color.border.state.inverse : textButtonTokens.color.border.state.default
                }
            };
        },
        disabled: {
            true: {
                pointerEvents: "none"
            }
        }
    }
};
var AnchorFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "a",
    accessibilityRole: "link",
    textDecorationLine: "none",
    display: "flex",
    position: "relative"
}));
var ButtonFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.View, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "button",
    accessibilityRole: "button"
}));
var AnchorOrButtonFrame = (0,_shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_6__/* .createAnchorOrButtonFrame */ .r)({
    AnchorFrame: AnchorFrame,
    ButtonFrame: ButtonFrame
});
/**
 * The TextButton component is a pressable element that's styled to be
 * less-pronounced than the regular Button component. The component is similar
 * to the "nav" variant of the Link component in the old version of bricks. In
 * this version of bricks, TextButton and Link are separate components. Use Link
 * when the clickable text should be inline with other text (e.g., in the middle
 * of a paragraph), and use TextButton when the clickable text should be set off
 * on its own. With TextButton, you can also pass a `chevronIcon` prop to show a
 * chevron on either the left or the right side of the button text.
 *
 * Like Button, TextButton accepts an `href` prop that lets you use the
 * component for URL-based navigation. Refer to the Button component docs for
 * more information. Also refer to the Button docs for information on flexbox
 * and analytics props.
 */ var TextButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function TextButton(_param, ref) {
    var variant = _param.variant, disabled = _param.disabled, label = _param.label, onHoverIn = _param.onHoverIn, onHoverOut = _param.onHoverOut, chevronIcon = _param.chevronIcon, fontWeight = _param.fontWeight, _size = _param.size, size = _size === void 0 ? "medium" : _size, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "variant",
        "disabled",
        "label",
        "onHoverIn",
        "onHoverOut",
        "chevronIcon",
        "fontWeight",
        "size"
    ]);
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isHovering = _$ref[0], setIsHovering = _$ref[1];
    var hoverNone = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.useMedia)().hoverNone;
    var handleHoverIn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        !hoverNone && setIsHovering(true);
        onHoverIn === null || onHoverIn === void 0 ? void 0 : onHoverIn(e);
    }, [
        hoverNone,
        onHoverIn
    ]);
    var handleHoverOut = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        !hoverNone && setIsHovering(false);
        onHoverOut === null || onHoverOut === void 0 ? void 0 : onHoverOut(e);
    }, [
        hoverNone,
        onHoverOut
    ]);
    var color = disabled ? textButtonTokens.color.content.state.inactive[variant] : isHovering ? textButtonTokens.color.content.state.hover[variant] : textButtonTokens.color.content[variant];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(AnchorOrButtonFrame, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        variant: variant,
        disabled: disabled,
        "aria-disabled": disabled,
        focusable: !disabled,
        onHoverIn: handleHoverIn,
        onHoverOut: handleHoverOut,
        ref: ref
    }, rest), {
        children: [
            chevronIcon === "left" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_generated_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                size: size === "large" ? 24 : 20,
                color: color
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_Text__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                tag: "span",
                typography: textButtonTokens.typography[size],
                textDecorationLine: variant === "primary" || chevronIcon ? "none" : "underline",
                color: color,
                fontWeight: fontWeight ? textButtonTokens.fontWeight[fontWeight] : undefined,
                children: label
            }),
            chevronIcon === "right" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_generated_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                size: size === "large" ? 24 : 20,
                color: color
            })
        ]
    }));
});


/***/ }),

/***/ 39390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ useInputName; },
/* harmony export */   "N7": function() { return /* binding */ useFrameFocus; },
/* harmony export */   "U0": function() { return /* binding */ useInputId; },
/* harmony export */   "U1": function() { return /* binding */ useInputState; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88149);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_1__);



var useInputId = function(id) {
    var backupId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
    return id || backupId;
};
/**
 * There's a bug in tamagui where the `name` attribute doesn't get set on
 * styled components. See: https://github.com/tamagui/tamagui/issues/2495
 *
 * Use this hook to manually set the `name` attribute on styled components. Note
 * that this attribute must be used on inputs if you want to use the FormData
 * API (without it, `new FormData(<form element>)` will be empty).
 */ var useInputName = function(name) {
    // Have to use `any` because we need it to be an HTMLElement here but
    // elsewhere we use React Native types, which don't have `setAttribute`
    // (in reality, `setAttribute` will exist when `isWeb` is true)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.isWeb && name && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ref.current, HTMLElement)) {
            var ref1;
            (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.setAttribute("name", name);
        }
    }, [
        name
    ]);
    return ref;
};
var useFrameFocus = function(ref) {
    var focusRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var inputRef = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.useComposedRefs)(ref, focusRef);
    var handleFramePress = function() {
        var _$ref;
        (_$ref = focusRef.current) === null || _$ref === void 0 ? void 0 : _$ref.focus();
    };
    return {
        inputRef: inputRef,
        handleFramePress: handleFramePress
    };
};
var useInputState = function(param) {
    var disabled = param.disabled, errorText = param.errorText, invalid = param.invalid, onFocus = param.onFocus, onBlur = param.onBlur;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), focused = ref[0], setFocused = ref[1];
    var handleFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        setFocused(true);
        onFocus && onFocus(e);
    }, [
        onFocus
    ]);
    var handleBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        setFocused(false);
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    var state = disabled ? "inactive" : errorText || invalid ? "error" : focused ? "focused" : undefined;
    return {
        state: state,
        handleFocus: handleFocus,
        handleBlur: handleBlur,
        setFocused: setFocused
    };
};


/***/ }),

/***/ 90143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ TrackableContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _helpers_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77453);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22901);






/**
 * Container component for tracking components
 */ var TrackableContainer = function(_param) {
    var analyticsName = _param.analyticsName, trackImpression = _param.trackImpression, eventName = _param.eventName, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "trackImpression",
        "eventName"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var Component = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_Box__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref
    }, props));
    if (analyticsName && trackImpression) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_helpers_analytics__WEBPACK_IMPORTED_MODULE_5__/* .ComponentWithViewTracking */ .o, {
            Component: Component,
            analyticsName: analyticsName,
            eventName: eventName,
            ref: ref
        });
    }
    return Component;
};


/***/ }),

/***/ 91158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ isKeyOfObject; }
/* harmony export */ });
/**
 * Returns whether the given key is a key of the given object.
 */ function isKeyOfObject(key, obj) {
    return !!key && key in obj;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5653,4607,9115,820,9560,1028,8579,6184,8948,6772,5300,6240,1500,1154,6492,3476,2766,589,4482,9606,3931,5779,9774,2888,179], function() { return __webpack_exec__(56771); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);